<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
    <div fxFlex>Filter Options</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>

  <mat-dialog-content class="mat-typography" fxFlex>
    <form>
      <app-card title="Additional Filter Options" [collapsed]="false">
        <app-mat-text-input [(ngModel)]="firstName" label="First Name"
                            name="firstName"></app-mat-text-input>
        <app-mat-text-input [(ngModel)]="lastName" label="Last Name" name="lastName"></app-mat-text-input>
        <app-mat-phone-number-input [(ngModel)]="phoneNumber" label="Phone Number"
                                    name="phoneNumber"></app-mat-phone-number-input>
        <app-mat-phone-number-input [(ngModel)]="faxNumber" label="Fax Number"
                                    name="faxNumber"></app-mat-phone-number-input>
        <app-mat-phone-number-input [(ngModel)]="mobileNumber" label="Mobile Number"
                                    name="mobileNumber"></app-mat-phone-number-input>

        <app-mat-text-input [(ngModel)]="companyName" label="Company Name"
                            name="companyName"></app-mat-text-input>
        <app-mat-text-input [(ngModel)]="position" label="Position" name="position"></app-mat-text-input>
        <app-mat-text-input [(ngModel)]="speedDial" label="Speed Dial"
                            name="speedDial"></app-mat-text-input>
      </app-card>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="closeSendConfirmPopup('proceed')">Filter</button>
    <button mat-button (click)="closeSendConfirmPopup('close')">Close</button>
  </mat-dialog-actions>
</div>
